import * as React from "react";
import { cn } from "@/lib/utils";

type InputProps = React.ComponentProps<"input">;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", onChange, value, ...props }, ref) => {
    const isFile = type === "file";

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!onChange) return;

      let val: string | number | null = e.target.value;

      switch (type) {
        case "number":
          val = val === "" ? "" : Number(val);
          break;
        case "file":
          return onChange(e);
        default:
          break;
      }

      onChange({
        ...e,
        target: {
          ...e.target,
          value: val,
        },
      } as React.ChangeEvent<HTMLInputElement>);
    };

    return (
      <input
        type={type}
        data-slot="input"
        ref={ref}
        onChange={handleChange}
        {...(!isFile ? { value: value ?? "" } : {})}
        className={cn(
          "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          "bg-[var(--background)] text-[var(--foreground)] border border-[var(--muted)]",
          className
        )}
        {...props}
      />
    );
  }
);

Input.displayName = "Input";

export { Input };
